import React from 'react';
import Markup from '../../../../base/Markup/Markup';
import { BoxCardStoryblok } from '../../../../types/storyblok';
import { Type } from '../../../../base/Type/Type';
import { Box } from '../../../../base/Box/Box';
import Link from '../../../../base/Link/Link';

const BoxCard = ({
  title,
  richText,
  buttonText,
  buttonUrl,
}: BoxCardStoryblok) => (
  <Box as="article" className="rounded border p-10" border overlayOverBkg>
    <Box as="div" className="flex h-full flex-col justify-between">
      <Box as="div">
        <Type as="h2" typography="subheading">
          {title}
        </Type>

        <Markup content={richText} className="mb-10 text-p1" />
      </Box>
      <Box as="div">
        <Link href={buttonUrl} variant="primary">
          {buttonText}
        </Link>
      </Box>
    </Box>
  </Box>
);

export default BoxCard;
